export default __webpack_public_path__ + "tutor.png";